import React, { memo } from 'react';

import { Step, StepLabel, Stepper } from '@mui/material';
import StepConnector from '@mui/material/StepConnector';
import PropTypes from 'prop-types';

import StepIconComponent from './StepIconComponent';
import { connectorStyles, stepperStyles } from './StepperCDS.styles';

const StepperCDS = ({ activeStep, steps, ...props }) => {
  const activeStepIndex = steps.findIndex(step => step.value === activeStep);

  return (
    <Stepper {...props} activeStep={activeStepIndex} connector={null} sx={stepperStyles}>
      {steps.map(({ label }, index) => (
        <Step key={index}>
          <StepLabel StepIconComponent={StepIconComponent}>{label}</StepLabel>
          <StepConnector sx={connectorStyles} />
        </Step>
      ))}
    </Stepper>
  );
};

StepperCDS.propTypes = {
  activeStep: PropTypes.string.isRequired,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default memo(StepperCDS);
